<ng5-slider class="itb-rang-slider" [(value)]="minValue" [(highValue)]="maxValue" [options]="options"
(valueChange)="onMinValueChange($event)"
(highValueChange)="onHighValueChange($event)"></ng5-slider>